import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Editor, schema, toHTML, Toolbar } from 'ngx-editor';
import { IMessengerConnector } from '../../../types/all.type';
import { AllService } from '../../../services/all.service';
import { InterfaceService } from '../../../services/interface.service';
import { Subject, takeUntil } from 'rxjs';
import { ContextMenuComponent, ContextMenuService } from 'ngx-contextmenu';
import { ChatGptService } from '../../../services/chat-gpt.service';
import { NotifierWrapService } from '../../../services/notifier-wrap.service';
import { debounceTime } from 'rxjs/operators';
import { SenderService } from '../../../services/sender.service';
import { AllMessengersService } from '../../../pages/page-start/all-messengers.service';
import { log } from '../../../functions';
import { ToursService } from '../../../services/tours.service';
import { ModalService } from '../../../services/modal.service';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-message-editor',
  templateUrl: './message-editor.component.html',
  styleUrls: ['./message-editor.component.scss']
})
export class MessageEditorComponent implements OnInit, OnDestroy {
  @Input() formControl: AbstractControl | false = false;
  @Input() showImprove = true;
  @Output() onSubmit = new EventEmitter();
  @ViewChild(ContextMenuComponent) public contextMenu: ContextMenuComponent;
  public isLoaded = true;

  constructor(
    public modalService: ModalService,
    private toursService: ToursService,
    public allMessengersService: AllMessengersService,
    public senderService: SenderService,
    public notifierWrapService: NotifierWrapService,
    public chatGptService: ChatGptService,
    public contextMenuService: ContextMenuService,
    public interfaceService: InterfaceService,
    public allService: AllService,
    public cd: ChangeDetectorRef,
  ) {
  }

  get textMessage(): string {
    if (this.formControl) {
      return this.formControl.value;
    }
    return this.allMessengersService.arTextVariations[this.currentVariationIndex].text;
  }

  set textMessage(val) {
    if (this.formControl) {
      this.formControl.setValue(val);
    }
    this.allMessengersService.arTextVariations[this.currentVariationIndex].text = val;
  }

  get currentVariation(): { text: string } {
    return this.allMessengersService.arTextVariations[this.currentVariationIndex];
  }

  get hasVariations(): boolean {
    return this.Service.type === 'sender' && this.textMessage?.length > 0;
  }

  get placeholderVariant() {
    if (this.currentVariationIndex === 0) {
      return this.placeholder;
    } else {
      return this.isLoaded ? 'Дополнительный текст, для чередования при рассылке' : `Идет процесс перефразирования из главного текста с помощью ChatGPT, для чередования при рассылке.`;
    }
  }

  @Output() onFocus = new EventEmitter<any>();
  @Output() onKeyUp = new EventEmitter<any>();
  @Output() onInput = new EventEmitter<any>();

  @Input() Service: IMessengerConnector;
  private destroy$: Subject<void> = new Subject();
  @Input() placeholder = '';
  toolbar: Toolbar = [
    // default value
    ['bold', 'italic'],
    ['underline', 'strike'],
    // ['code', /*'blockquote'*/],
    [/*'ordered_list', 'bullet_list'*/],
    /*[{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],*/
    // ['link', /*'image'*/],
    [/*'text_color', 'background_color'*/],
    [/*'align_left', 'align_center', 'align_right', 'align_justify'*/],
    // ['format_clear'],
  ];

  public currentVariationIndex = 0;
  private rephrasePrompt = 'Моя главная просьба обязательно переформулировать текст, что бы он отличался от предоставленного ниже (просьба 1). После добавь смайлы по смыслу как можно больше (просьба 2). Оформи структуру, включая переносы строк (просьба 3). Используй HTTML разметку используя только HTTML теги: b, strong, u, i, br - но не часто (просьба 4). Сделай текст не похожим на спам (просьба 5). Буду благодарен, если ты сможешь выполнить эти просьбы в указанном порядке, вот текст';
  // public offerPrompt = 'Оформи данный текст, для рассылки, сделай продающим и привлекающим внимание, (разрешешны HTTML теги b, strong, u, i, br) и добавь смайлы, так же добавь структуру';
  public offerPrompt = 'Моя главная просьба сделай текст продающим и привлекающим внимание (просьба 1). После добавь смайлы по смыслу как можно больше (просьба 2). Оформи структуру, включая переносы строк (просьба 3). Используй HTTML разметку используя только HTTML теги: b, strong, u, i, br - но не часто (просьба 4). Сделай текст не похожим на спам (просьба 5). Буду благодарен, если ты сможешь выполнить эти просьбы в указанном порядке, вот текст"';

  public noSpamPrompt = 'Перепиши данный текст для рассылки, что бы он небыл похож на спам, используя HTTML разметку схожую с иcпользующейся, вот текст';
  public addTextPrompt = 'Допиши данный текст для рассылки';
  public cutTextPrompt = 'Сократи данный текст для рассылки';


  /////
  isShowVariations = false;

  // make sure to destory the editor
  ngOnInit(): void {
    this.interfaceService.clearTextArea$.pipe(takeUntil(this.destroy$), debounceTime(100)).subscribe(() => {
      this.Service.message = '';
      this.allMessengersService.resetTextVariations$.next();
      this.Service.message = '';
    });
    this.interfaceService.$onEdtMessage.pipe(takeUntil(this.destroy$), debounceTime(100)).subscribe(() => {

      this.allMessengersService.resetTextVariations$.next();
      setTimeout(() => {
        if (this.Service.editMessage) {
          this.textMessage = this.Service.editMessage.text;
          try {
            const textVariations = JSON.parse(this.Service.editMessage.sender.text_variations);
            if (textVariations?.length > 0) {
              log('Restore texts', textVariations);
              this.allMessengersService.arTextVariations = this.allMessengersService.arTextVariations.filter((v) => v.text);
              textVariations.map((v) => {
                this.allMessengersService.arTextVariations.push(v);
              });
              this.isShowVariations = true;
              this.cd.detectChanges();
            }
          } catch (e) {
            console.error(e);
          }
        }
      }, 150);

    });
    this.allMessengersService.resetTextVariations$.next();
    this.interfaceService.openChat$.pipe(takeUntil(this.destroy$), debounceTime(100)).subscribe(() => {
      this.cd.detectChanges();
    });
    this.allMessengersService.resetTextVariations$.pipe(takeUntil(this.destroy$), debounceTime(100)).subscribe(() => {
      this.isShowVariations = false;
      this.currentVariationIndex = 0;
      this.textMessage = '';
      this.cd.detectChanges();
    });
    this.interfaceService.editor = new Editor({
      content: '',
      history: true,
      keyboardShortcuts: true,
      inputRules: false,
      plugins: [], // https://prosemirror.net/docs/guide/#state
      nodeViews: {}, // https://prosemirror.net/docs/guide/#state,
      attributes: {}, // https://prosemirror.net/docs/ref/#view.EditorProps.attributes
      linkValidationPattern: '',
    });
    /*this.interfaceService.editor.update.subscribe((v) => {
    });*/
    this.interfaceService.editor.valueChanges.pipe(takeUntil(this.destroy$), debounceTime(100)).subscribe((res) => {
      setTimeout(() => {
        const clearText = toHTML(res, schema).toString();
        if (this.currentVariationIndex === 0) {
          this.Service.message = clearText;
        }
        this.textMessage = clearText;
      });
      this.setTextAreaPosition();
      this.onKeyUp.emit('valueChanges');
      this.onInput.emit('valueChanges');
    });
  }


  public setTextAreaPosition() {
    this.allService.textAreaPosition = this.interfaceService.editor.view.state.selection.$anchor.pos;
  }

  // Change text
  setTextMessage(index: number): void {
    this.currentVariationIndex = index;
    if (this.allMessengersService.arTextVariations[index].text?.length === 0) {
      console.log('------------textMessage: ', this.Service.message, this.textMessage, this.currentVariationIndex);
      this.replaceTextFromPrompt(this.Service.message, this.allMessengersService.arTextVariations[index], this.rephrasePrompt);
    }
    this.cd.detectChanges();
  }

  showVariations() {
    this.isShowVariations = true;
    this.setTextMessage(1);
    this.toursService.tourTextVariationsNotShow = true;
  }

  public contextMenuOpen(data: any): void {
    // this.notifierWrapService.onOpenPlay();
    this.contextMenuService.show.next({
      anchorElement: data.event.target,
      // Optional - if unspecified, all context menu components will open
      contextMenu: this.contextMenu,
      event: (data.event as any),
      item: data.item
    });
    data.event.preventDefault();
    data.event.stopPropagation();
  }

  public isText(textMessage: { text: string }): boolean {
    return textMessage.text?.length > 0;
  }

  addSmile(textMessage: { text: string }): void {
    const prompt = `Добавь смайлы в этот HTML`;
    this.replaceTextFromPrompt(textMessage.text, textMessage, prompt);
  }

  rePhrase(textMessage: { text: string }): void {
    this.replaceTextFromPrompt(textMessage.text, textMessage, this.rephrasePrompt);
  }

  replaceTextFromPrompt(textOriginal: string, textReplace: { text: string }, prompt: string): void {
    const length = textOriginal?.length;
    textOriginal = this.senderService.clearHTML(textOriginal);
    if (length < 50) {
      this.notifierWrapService.notify('error', 'Сначала укажите текст рассылки, он слишком короткий');
      return;
    }
    this.isLoaded = false;
    this.cd.detectChanges();
    prompt = `${prompt}:\n ${textOriginal}`;
    this.chatGptService.sendPrompt(prompt).pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        textReplace.text = res.choices[0].message.content;
        this.isLoaded = true;
        this.cd.detectChanges();
        this.chatGptService.load$.next(true);
      }, error => {
        this.chatGptService.load$.next(false);
        this.isLoaded = true;
        this.interfaceService.errorHandling(error);
      });
  }

  ngOnDestroy() {
    this.interfaceService.editor.destroy();
    this.destroy$.next();
    this.destroy$.complete();
  }

  get isShowAddVariant(): boolean {
    return !this.allMessengersService.arTextVariations.find((v) => !v.text);
  }

  addVariation(): void {
    this.allMessengersService.arTextVariations.push({text: ''});
    const findIndex = this.allMessengersService.arTextVariations.findIndex((v) => !v.text);
    this.setTextMessage(findIndex);
  }

  textareaEnter($event: any) {
    this.onSubmit.next($event);
  }
}
